export default __webpack_public_path__ + "static/media/hero-image_prikkel.e9a94aad.svg";